import {
  Button,
  Grid,
  IconButton,
  Icons,
  Tabs,
} from "@pushpress/shared-components";

interface PlanListHeaderProps {
  createPlanFlag: boolean;
  selectedTabIndex: number;
  onChangeTabIndex: (index: number) => void;
  onCreateCategoryClick: VoidFunction;
  onCreatePlanClick: VoidFunction;
}

function PlansListHeader(props: PlanListHeaderProps) {
  const {
    createPlanFlag,
    selectedTabIndex,
    onChangeTabIndex,
    onCreateCategoryClick,
    onCreatePlanClick,
  } = props;
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Tabs
          tabHeaders={["Active plans", "Deleted plans"]}
          selectedIndex={selectedTabIndex}
          changeTab={onChangeTabIndex}
          onTabClick={onChangeTabIndex}
          align="left"
          hideWithCss
          onTabFocus={onChangeTabIndex}
        />
      </Grid>
      <Grid item>
        <Grid container spacing={4} alignItems="center">
          <Grid item>
            <IconButton
              icon={Icons.NewPage}
              href="/landing/plans"
              target="_blank"
              color="#2A3540"
              tooltip="Open website plan list"
            />
          </Grid>
          <Grid item>
            <Button
              buttonType="secondary"
              text="Category"
              icon={Icons.Plus}
              iconLocation="left"
              size="large"
              onClick={onCreateCategoryClick}
            />
          </Grid>
          <Grid item>
            <Button
              buttonType="primary"
              text="Plan"
              icon={Icons.Plus}
              iconLocation="left"
              size="large"
              href={createPlanFlag ? undefined : "/plans/create"}
              onClick={createPlanFlag ? onCreatePlanClick : undefined}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default PlansListHeader;
